// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import React from "react";

const AlertWarning = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="16" viewBox="0 0 18 16">
            <path
                fill="currentColor"
                d="M9,0 L0,16 L18,16 L9,0 Z M9.84375,5.71428571 L9.84375,6.57142857 L9.84375,10.5714286 L9.84375,11.4285714 L8.15625,11.4285714 L8.15625,10.5714286 L8.15625,6.57142857 L8.15625,5.71428571 L9.84375,5.71428571 Z M8.15625,12.5714286 L9.84375,12.5714286 L9.84375,14.2857143 L8.15625,14.2857143 L8.15625,12.5714286 Z"
            />
        </svg>
    );
};

export default React.memo(AlertWarning);
